import { useEffect, useState, useRef, useCallback } from 'react'
import { getObjectsWithFilter, deleteObject } from '../../api/apiClientCrud'
import { toast } from 'react-toastify'
import { Box } from '@mui/material'
import MyTable from '../fields/table/MyTable'
import Toolbar from '../toolbar/Toolbar'
import Loading from '../common/Loading'

function ListModule({ options, toolbar, refresh = false, setReturnData, setParentObject, parentObject }) {
  const [objects, setObjects] = useState([])
  const toastId = useRef(null)
  const [filters, setFilters] = useState(null)
  const [queryFilters, setQueryFilters] = useState({})
  const [isFiltered, setIsFiltered] = useState(false)
  const [isDelete, setIsDelete] = useState(false)
  const [page, setPage] = useState(0)
  const [isUpdated, setIsUpdated] = useState(false)
  const [columns, setColumns] = useState(options.columns)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchObjectsFilters = async () => {
      try {
        const appliedFilters = Object.keys(queryFilters).length ? queryFilters : options.objectFilter()
        const res = await getObjectsWithFilter(options.objectType, appliedFilters)

        setObjects(res.data)
        setPage(0)

        if (options.returnData) {
          setReturnData?.(res.data[options.objectType])
        }
      } catch (err) {
        toast.error('Erreur lors du chargement', { autoClose: 2000 })
      } finally {
        setIsFiltered(false)
        setIsDelete(false)
        setIsUpdated(false)
        setLoading(false)
      }
    }

    fetchObjectsFilters()
  }, [refresh, isFiltered, isDelete, isUpdated, queryFilters])

  useEffect(() => {
    if (!filters || !options.objectFilter) return

    try {
      const baseFilter = options.objectFilter() || {}
      const parsedFilters = JSON.parse(filters)
      const combinedFilter = { $and: { ...baseFilter, ...parsedFilters } }

      setQueryFilters(combinedFilter)
    } catch (error) {}
  }, [filters])

  const deleteData = useCallback(
    async (id) => {
      toastId.current = toast.loading('Suppression en cours')

      try {
        const res = await deleteObject(options.objectType, id)

        if (res.status === 200) {
          toast.update(toastId.current, {
            type: 'success',
            render: 'Suppression terminée',
            autoClose: 2000,
            isLoading: false,
            data: { exclude: true }
          })

          setIsDelete(true)

          if (setParentObject) {
            const currentObjects = objects?.[options.objectType] || []
            const updatedObjects = currentObjects.filter((ob) => ob.id !== Number(res.data.id))

            setParentObject({
              ...parentObject,
              [options.objectType]: updatedObjects.length ? updatedObjects : []
            })
          }
        }
      } catch (e) {
        toast.update(toastId.current, {
          type: 'error',
          render: e.data?.message || e.response?.statusText || e.message || 'Une erreur est survenue.',
          autoClose: 2000,
          isLoading: false
        })
      }
    },
    [options.objectType, objects, parentObject, setParentObject]
  )

  if (!options || !options.columns?.length)
    return (
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          height: '100%',
          minHeight: '100px',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Loading />
      </Box>
    )

  if (loading)
    return (
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          height: '100%',
          minHeight: '100px',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Loading />
      </Box>
    )

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        overflow: 'hidden'
      }}
    >
      <Toolbar
        options={toolbar}
        setIsFiltered={setIsFiltered}
        setFilters={setFilters}
        setIsUpdated={setIsUpdated}
        setColumnsParent={setColumns}
      />
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden', pb: 3 }}>
        <MyTable
          data={objects}
          deleteData={deleteData}
          tableOptions={options}
          columns={columns}
          activePage={page}
          setIsUpdated={setIsUpdated}
        />
      </Box>
    </Box>
  )
}

export default ListModule
